import AudioSoundFeedback from './AudioSoundFeedback';
import LiteralSoundFeedback from './LiteralSoundFeedback';

export default process.env.REACT_APP_LITERAL_LANGUAGE === 'true'
  ? LiteralSoundFeedback
  : AudioSoundFeedback;
